import React, {Dispatch, SetStateAction, useContext, useEffect, useState} from "react";
import dayjs from "dayjs";
import Card from "../../../Components/Card";
import ResourceTable, {IGenerateColumns} from "../../../Components/ResourceTable";
import {nfes} from "../../../Requests";
import VisibilityIcon from "@mui/icons-material/Visibility";
import useGlobalContext from "../../../Hooks/useGlobalContext";
import Modal from "../../../Components/Modal";
import CardsNFEDetailsData from './CardsNFEDetailsData';

interface INFEsListProps {
    spedFiscalId?: number | null;
    dataInicioCompetencia?: string;
    dataFimCompetencia?: string;
}

const Index: React.FC<INFEsListProps> = ({ spedFiscalId, dataInicioCompetencia, dataFimCompetencia }) => {

    const {setLoading: setLoadingGlobal} = useGlobalContext();
    const [openModal, setOpenModal] = useState<boolean>(false);
    const [details, setDetails] = useState<object>({});
    const [rechargeRequest, setRechargeRequest] = useState<number>(0);

    // Força recarga quando spedFiscalId mudar
    useEffect(() => {
        console.log('[NFEsList] spedFiscalId change ->', spedFiscalId);
        console.log('[NFEsList] recarregar tabela (spedFiscalId change)');
        setRechargeRequest(prev => prev + 1);
    }, [spedFiscalId]);

    const actionView = (setLoading: Dispatch<SetStateAction<boolean>>) => async (id: number) => {
        setLoadingGlobal && setLoadingGlobal(true);
        setDetails({});
        const value = await nfes.get(id + '');
        setDetails(value ?? {});
        setLoadingGlobal && setLoadingGlobal(false);
        setOpenModal(true);
    }

    const handleCloseModal = () => {
        setOpenModal(false);
    }

    const generateColumns: IGenerateColumns = ({setLoading}) => {
        return [
            {field: 'num_doc', type: 'string', headerName: 'NÚMERO DOC', width: 150},
            {field: 'chv_nfe', type: 'string', headerName: 'CHAVE', width: 400},
            {
                field: 'dt_emissao', 
                type: 'string', 
                headerName: 'DATA DE EMISSÃO', 
                width: 200,
                valueGetter: (params: any) => {
                    const raw = params?.row?.dt_emissao;
                    const br = params?.row?.dt_emissao_br;
                    // Se existir BR, usa. Caso contrário, formata ISO (YYYY-MM-DD) para DD/MM/YYYY
                    if (br) return br;
                    if (raw && /^\d{4}-\d{2}-\d{2}/.test(raw)) {
                        const [y, m, d] = raw.split('-');
                        return `${d}/${m}/${y}`;
                    }
                    return raw || '';
                },
                renderCell: (params: any) => {
                    const raw = params?.row?.dt_emissao;
                    const br = params?.row?.dt_emissao_br;
                    if (br) return <span>{br}</span>;
                    if (raw && /^\d{4}-\d{2}-\d{2}/.test(raw)) {
                        const [y, m, d] = raw.split('-');
                        return <span>{`${d}/${m}/${y}`}</span>;
                    }
                    return <span>{raw || ''}</span>;
                }
            },
            {field: 'vl_doc', type: 'number', headerName: 'VALOR DO DOCUMENTO', width: 200},
            {field: 'vl_icms', type: 'number', headerName: 'VALOR DO ICMS',  width: 200},
            {field: 'vl_icms_st', type: 'number', headerName: 'VALOR DO ICMS ST', width: 200},
            {
                field: 'acao_visualizar',
                headerName: 'Detalhes',
                align: 'center',
                headerAlign: 'center',
                flex: 1,
                minWidth: 50,
                renderCell: (params: any) => (
                    <div style={{cursor: 'pointer'}}
                         onClick={() => actionView(setLoading)(params?.row?.identifier || 0)}>
                        <VisibilityIcon sx={{color: '#1c2e4a'}}/>
                    </div>
                )
            },
        ];

    }

    return (<>
        <Card
            titleDashboard='Listagem de Notas Fiscais do SPED Fiscal'
            icon='ProductionQuantityLimitsIcon'
            paperConfig={{minHeight: 704}}
            marginTop='0'
            lineDividerHeader={false}
        >
            <ResourceTable
                request={nfes}
                generateColumns={generateColumns}
                pageSizeOptions={[10]}
                getRowId={(row) => row?.identifier}
                minHeight={630}
                rechargeRequest={rechargeRequest}
                handlingRequestCall={async (request, params) => {
                    const res = await request.get(params);
                    const sample = Array.isArray(res?.data) ? res.data.slice(0, 3) : res?.data;
                    console.log('[NFEsList] resposta', { total: res?.total ?? res?.meta?.total, sample });
                    return res;
                }}
                filterDefinitions={({startDate,endDate,num_doc,chv_nfe,page,recordsPerPage}) => {
                    const filters = {
                        startDate: dataInicioCompetencia || startDate,
                        endDate: dataFimCompetencia || endDate,
                        num_doc,
                        chv_nfe,
                        sped_fiscal_id: spedFiscalId,
                        page,
                        recordsPerPage
                    };
                    console.log('[NFEsList] filters enviados', filters);
                    return filters;
                }}
                />
            <Modal
                    title='Detalhes da Nota Fiscal'
                    open={openModal}
                    closeModal={handleCloseModal}
                    maxWidth="xl"
                    padding="16px"
                >
                    <CardsNFEDetailsData data={details}/>
                </Modal>
        </Card>
    </>);
}

export default Index;